import { useNavigate } from "react-router-dom";
import { ROUTES } from "./routePaths";
import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import useAppStore from "../store/useAppStore";

export default function ProtectedRoute({ children }) {
  const userToken = useAppStore((state) => state.userToken);

  if (!userToken) {
    return <Navigate to={ROUTES.HOME} replace />;
  }

  return children;
}
